module.exports = __webpack_public_path__ + "static/technology-banner-d50a670ef1fa03792947123d4ceb4073.jpg";